import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getUrgencyCodesListAPI = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/urgency-codes`,
    method: 'get',
  });
};

export type UrgencyCodesListResponse = {
  codeDesc: string; // 'TIME CRITICAL'
  codeId: string; // 'TC'
}[];

export const fetchUrgencyCodesList = async (): Promise<UrgencyCodesListResponse> => {
  const response: AxiosResponse<UrgencyCodesListResponse> = await getUrgencyCodesListAPI();
  return response.data;
};
